import { useCallback, useEffect } from 'react';
import { useWidgetScopeContext } from '../../../../../../form/fillable/WidgetScopeContext.tsx';
import { useRepeatableListEditor } from '../../../repeat-controller/useRepeatableListEditor.ts';
import { type IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps.ts';
import { type IButtonActionListRemove } from '../IButtonAction.ts';

export function ButtonActionListRemoveLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionListRemove>,
) {
  const { action, buttonWidgetOptions, onClickSubject } = props;

  const { listIndex } = useWidgetScopeContext();

  const { handleRemove } = useRepeatableListEditor(
    buttonWidgetOptions.name,
    action.listReference,
  );

  const handleAction = useCallback(() => {
    if (!action.listReference) {
      console.warn(`ListAddActionComponent: listReference is not defined`);
      return;
    }

    if (listIndex == null) {
      console.warn(`ListAddActionComponent: listIndex is not defined`);
      return;
    }

    handleRemove(listIndex);
  }, [action.listReference, handleRemove, listIndex]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
